﻿import {JsonFetchJson} from "../../Helper/FetchHelper";
import {ResponseApi} from "../../Model/ResponseApi";
import {IProjetModel} from "../../Model/Projet/ProjetModel";
import {OnProjetAdd} from "../../Delegates/ProjetDelegate";

export class ProjetCreateController { 
    public static Create = async (fkClient:string) => {
        return JsonFetchJson.Get<ResponseApi<IProjetModel>>(`/projet/create/${fkClient}`)
            .then(response => {
                OnProjetAdd.Fire(response.Data);
                return response.Data;
            })
    }
}